import { render, staticRenderFns } from "./delete-mandate-modal.vue?vue&type=template&id=0317269a&"
import script from "./delete-mandate-modal.vue?vue&type=script&lang=js&"
export * from "./delete-mandate-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports